/**
 * e.g. you can render richtext or simple text, when migrating field type based on this
 **/
export const isLocalizedObjectString = (obj: object) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && typeof (obj as any)[key] === "string") {
      return true;
    }
  }

  return false;
};
